export default function CoreRole() {
  return (
    <section className="bg-white py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-[1280px] mx-auto mx-auto">
          <p className="font-serif italic text-plum-dark text-sm md:text-base mb-3">
            Comprendre le mécanisme
          </p>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-plum mb-8 leading-tight">
            Gond, paumelle, charnière : à quoi ça{" "}
            <span className="font-serif italic">sert</span>
          </h2>

          <div className="space-y-6 text-plum-dark text-base md:text-lg leading-relaxed">
            <p>
              Le gond, la paumelle et la charnière sont les pièces qui relient le vantail (la partie mobile) au dormant (la partie fixe) de votre fenêtre. Ce sont elles qui supportent tout le poids de l'ouvrant et lui permettent de pivoter lors de l'ouverture. Sur une fenêtre PVC ou aluminium, on parle généralement de gond ou de paumelle — un axe métallique avec un roulement ou une bague qui encercle le pivot. Sur une fenêtre en bois, on utilise souvent des charnières plus traditionnelles. Quelle que soit la terminologie, le rôle est identique : porter le vantail, guider son mouvement et maintenir l'alignement du cadre.
            </p>
            <p>
              Avec les années, le roulement s'use, la bague s'écrase ou l'axe s'oxyde. Le vantail descend alors de quelques millimètres et commence à frotter contre le dormant ou le seuil. La fenêtre devient dure à manœuvrer, grince, ou ne ferme plus correctement. Dans certains cas, le gond se dévisse complètement et la fenêtre risque de se détacher. Nos techniciens remplacent le gond ou la paumelle usée par une pièce neuve, réajustent la hauteur du vantail, et lubrifient le mécanisme pour retrouver une ouverture fluide et silencieuse.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}